import { CircularProgress } from '@mui/material';
import axios from 'axios';
import moment from 'moment';
import React from 'react';
import { toast } from 'react-toastify';
import { Footer, MenuBar } from '../../layout/welcome';
import { errorMessage } from '../../utils/notification';
import { settingContext } from '../../context/Setting/Setting';
import { VideoJS } from '../../components';
import { Email } from '@mui/icons-material';

const Index = () => {
    const [isLoading, setLoading] = React.useState(false);
    const [data, setData] = React.useState({});
    const [input, setInput] = React.useState({});
    const { page } = React.useContext(settingContext);
    const playerRef = React.useRef(null);

    const handlePlayerReady = (player) => {
        playerRef.current = player;

        // You can handle player events here, for example:
        player.on("waiting", () => {
            console.log("player is waiting");
        });

        player.on("dispose", () => {
            console.log("player will dispose");
        });
    };
    return (
        <div id="page-top" class="home">
            <div id="page-wrap">
                <MenuBar menuIndex="verify" setting={page?.setting} />
                <section className="sub-banner sub-banner-course">
                    <div className="awe-static bg-sub-banner-course" style={{ backgroundImage: 'url(../img/course_banner.jpeg)' }} />
                    <div className="awe-overlay" />
                    <div className="container">
                        <div className="sub-banner-content">
                            <h1 className="text-center text-white font-bold text-5xl">Help</h1>
                        </div>
                    </div>
                </section>
                <section className="course-top">
                    <div className="container">
                        {/* <div className="flex justify-center w-100">
                            <p className="lead w-auto md:w-1/2 my-4">
                                Confirming the authenticity and validity of a certificate or document issued by Lakeshore. The purpose of certificate verification is to ensure that the certificate has not been altered or tampered with and that it was issued by the authorized body.
                            </p>
                        </div> */}

                        <div className="container my-4">
                            <div className="new-course  card-deck mb-3">
                                <div className="row ">
                                    <div className='col-md-8'>
                                        <div className="video-course-intro">
                                        <h2 className='sm bold black'>{page?.dashboard_tutorial?.header}</h2>
                                        <p>{page?.dashboard_tutorial?.description}</p>
                                            <div className="inner my-10">
                                                <div className="d-flex flex-column align-items-center justify-content-center">
                                                    <div className="w-100">
                                                        {page?.dashboard_tutorial?.video &&
                                                            <VideoJS
                                                                options={{
                                                                    autoplay: false,
                                                                    controls: true,
                                                                    responsive: true,
                                                                    fluid: true,
                                                                    skipForward: true,
                                                                    'playbackRates': [0.7, 1.0, 1.5, 2.0],
                                                                    sources: [
                                                                        {
                                                                            src: process.env.REACT_APP_LOCAL_FILE_PATH + 'video/' + page?.dashboard_tutorial?.video,
                                                                            type: "video/mp4",
                                                                        },
                                                                    ],
                                                                }}
                                                                onReady={handlePlayerReady}
                                                            />}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-4">

                                        <div className="card p-3 my-2">
                                            {/* <h4 className='sm bold black'>Click the button below to contact us via Email</h4> */}
                                            <div className="col-md-12 table_responsive my-10">
                                               <a href={`mailto:${page?.setting?.official_email}`} class="mc-btn btn-style-1"><Email /> Contact Us</a>
                                            </div>
                                        </div>

                                    </div>


                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <Footer />
            </div>
        </div>
    );
};

export default Index;